<template lang="pug">
  .page-header
    .main
      h1
        slot
    .extra
      slot(name="extra")
</template>

<script>
export default {
  name: 'PageHeader',
}
</script>

<style lang="scss" scoped>
.page-header {
  display: flex;
  border-bottom: 2px solid #e6e6e6;
}
.main {
  flex-grow: 1;
}

.extra {
  flex-grow: 0;
}
</style>
